<div id="content-section">
    <div id="content-main" class="responsive-content-main" [ngStyle]="{ 'margin-right': sidebarMaximized ? '370px' : '270px' }">
        <div id="content-sidebar" [ngClass]="{ 'responsive-content-sidebar': sidebarOpen, 'hide-responsive-sidebar': !sidebarOpen }" [ngStyle]="{ width: sidebarMaximized ? '350px' : '250px' }" style="position: fixed; right: 20px">
            <div class="sticky-top">
                <small class="bg-white">
                  <a href="#" class="d-none d-md-inline" [title]="sidebarMaximized ? 'Minimize Sidebar' : 'Maximize Sidebar'" (click)="sidebarMaximized = !sidebarMaximized; $event.preventDefault()">
                    <i class="fas" [ngClass]="{ 'fa-arrow-left': !sidebarMaximized, 'fa-arrow-right': sidebarMaximized }"></i>
                  </a>
                </small>
            </div>
            <div class="text-center pagination-small-margin pagination-center">
                <pagination
                    (pageChanged)="search($event, null)"
                    class="pagination-sm"
                    [boundaryLinks]="true"
                    [totalItems]="count"
                    [maxSize]="5"
                    [itemsPerPage]="searchParams.per_page"
                    [(ngModel)]="searchParams.page"
                    previousText="&lsaquo;"
                    nextText="&rsaquo;"
                    firstText="&laquo;"
                    lastText="&raquo;"
                ></pagination>
            </div>
            <div class="text-center pt-1">
                <span class="badge badge-primary" *ngIf="count > 1 || count == 0">{{count}} Receivables</span>
                <span class="badge badge-primary" *ngIf="count == 1">{{count}} Receivable</span>
            </div>
            <hr class="my-1" />
            <div class="clearfix"></div>
            <div class="sticky-top bg-white">
                <h5 class="pt-2">
                <div class="pull-right float-right">
                    <button type="button" [disabled]="searching" class="btn btn-sm btn-outline-secondary" (click)="clearSearch()">Clear</button>
                </div>
                <span>
                    Search&nbsp;&nbsp;
                    <a href="javascript: void(0)" title="Search" style="cursor: pointer" (click)="!searching ? (searchParams.page = 1) && search(null, true) : ''"><i *ngIf="!searching" class="fas fa-arrow-circle-right"></i><i *ngIf="searching" class="fas fa-spinner fa-pulse fa-fw"></i></a>
                </span>
                </h5>
                <hr class="my-1" />
            </div>
            <div class="row">
                <div class="col-md-12">
                    <form>
                        <div class="form-group">
                            <label for="matter-type">Matter Type:</label>
                            <select class="form-control" id="matter-type" [(ngModel)]="searchParams['search[matter_type_id]']" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                                <option [value]=""></option>
                                <option [value]="matterType.id" *ngFor="let matterType of searchOptions.matter_types">{{matterType.name}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="lead-attorney">Lead Attorney:</label>
                            <select class="form-control" id="lead-attorney" [(ngModel)]="searchParams['search[lead_attorney_id]']" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                                <option [value]=""></option>
                                <option [value]="attorney.id" *ngFor="let attorney of searchOptions.lead_attorneys">{{attorney.login}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="total-due">Total Due:</label>
                            <input class="form-control" type="text" id="total-due" [(ngModel)]="searchParams['search[total_due]']" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                        </div>
                        <div class="form-group">
                            <label for="user">Billed By User:</label>
                            <select class="form-control" id="user" [(ngModel)]="searchParams['search[user_id]']" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                                <option [value]=""></option>
                                <option [value]="user.id" *ngFor="let user of searchOptions.users">{{user.name}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <button (click)="searchParams.page = 1; search(null, true)" class="btn btn-primary btn-sm" style="width: 100%" type="button" [disabled]="searching">
                                Search
                                <span *ngIf="searching">
                                    &nbsp;
                                    <i class="fas fa-spinner fa-fw fa-pulse"></i>
                                </span>
                            </button>
                        </div>
                        <div class="form-group">
                            <a class="btn btn-primary btn-sm" style="width: 100%" type="button" target='_blank' [href]="'/' + downloadCsvUrl" (click)="downloadCsv()">
                                Download CSV
                            </a>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div id="content-inner" class="responsive-content-inner" style="padding: 0px 20px 10px 20px">
            <div class="container-shadow px-3 pb-4">
                <h2 class="pt-4 text-center">Receivables</h2>
                <hr class="mt-1 mb-2" />
                <div class="row p-4" style="overflow-x:auto;transform: rotateX(180deg);">
                    <table class="table" style="transform: rotateX(180deg);">
                        <thead>
                            <tr>
                                <th>Matter</th>
                                <th>Lead</th>
                                <th>Matter Type</th>
                                <th class="text-center">Paid Ago</th>
                                <th class="text-right">Over 180</th>
                                <th class="text-right">91-180 Days</th>
                                <th class="text-right">61-90 Days</th>
                                <th class="text-right">31-60 Days</th>
                                <th class="text-right">&lt; 30 Days</th>
                                <th class="text-right">Total Due</th>
                                <th class="text-right">Escrow</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let receivable of receivables">
                                <td><a [routerLink]="'/matters/' + receivable.matter_id">{{receivable.matter_id}}</a></td>
                                <td>{{receivable.lead}}</td>
                                <td>{{receivable.matter_type}}</td>
                                <td class="text-center">{{receivable.days_past_due}}</td>
                                <td class="text-right">
                                    <span *ngIf="receivable.over180">{{receivable.over180 | currency: 'USD':'symbol':'1.2-2'}}</span>
                                    <span *ngIf="!receivable.over180"></span>
                                </td>
                                <td class="text-right">
                                    <span *ngIf="receivable.over90">{{receivable.over90 | currency: 'USD':'symbol':'1.2-2'}}</span>
                                    <span *ngIf="!receivable.over90"></span>
                                </td>
                                <td class="text-right">
                                    <span *ngIf="receivable.days_90">{{receivable.days_90 | currency: 'USD':'symbol':'1.2-2'}}</span>
                                    <span *ngIf="!receivable.days_90"></span>
                                </td>
                                <td class="text-right">
                                    <span *ngIf="receivable.days_60">{{receivable.days_60 | currency: 'USD':'symbol':'1.2-2'}}</span>
                                    <span *ngIf="!receivable.days_60"></span>
                                </td>
                                <td class="text-right">
                                    <span *ngIf="receivable.days_30">{{receivable.days_30 | currency: 'USD':'symbol':'1.2-2'}}</span>
                                    <span *ngIf="!receivable.days_30"></span>
                                </td>
                                <td class="text-right">
                                    <span *ngIf="receivable.total_due">{{receivable.total_due | currency: 'USD':'symbol':'1.2-2'}}</span>
                                    <span *ngIf="!receivable.total_due"></span>
                                </td>
                                <td class="text-right">
                                    <span *ngIf="receivable.escrow">{{receivable.escrow | currency: 'USD':'symbol':'1.2-2'}}</span>
                                    <span *ngIf="!receivable.escrow"></span>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2">Receivable</td>
                                <td colspan="2" class="font-weight-bold">TOTALS</td>
                                <td *ngFor="let total of totals" class="text-right" style="border-left: solid;border-right: solid;border-bottom: solid;">
                                    <span *ngIf="total">{{total | currency: 'USD':'symbol':'1.2-2'}}</span>
                                    <span *ngIf="!total"></span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="responsive-sidebar-toggle-btn" (click)="sidebarOpen = !sidebarOpen">
    <button type="button" class="btn" [ngClass]="{ 'btn-primary': !sidebarOpen, 'btn-danger': sidebarOpen }">
      <i class="fas" [ngClass]="{ 'fa-bars': !sidebarOpen, 'fa-times': sidebarOpen }"></i>
    </button>
</div>